import { Form, Modal, notification, Tabs } from 'antd'
import { InputTextField, PrimaryButton, ScreenHeader } from 'components'
import { GenralTab } from 'page-components'
import React, { useMemo, useState } from 'react'
import { SettingsTabScreen, UsersService } from 'utility'
import { HeaderWrapper } from './dashboard'
import { useForm } from 'react-hook-form'
import styled from 'styled-components'
import * as Yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

export const SettingsScreen = () => {
  const [tab, setTab] = useState(SettingsTabScreen.General)
  const [isModalOpen, setIsModalOpen] = useState(false)

  const items = useMemo(
    () => [
      {
        key: SettingsTabScreen.General,
        label: 'Gernal',
        children: <GenralTab />,
      },
    ],
    [],
  )

  return (
    <div>
      <HeaderWrapper>
        <ScreenHeader text="Settings" />
      </HeaderWrapper>

      <div className="px-5 d-flex justify-content-end">
        <PrimaryButton onClick={() => setIsModalOpen(true)}>
          + Add Admin
        </PrimaryButton>
      </div>

      <div className="px-5">
        <div className="tabs-container">
          <Tabs
            defaultActiveKey="1"
            activeKey={tab}
            items={items}
            className="custom-tabs"
            onChange={key => setTab(key)}
          />
        </div>
      </div>

      <AddAdminModal
        visible={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  )
}

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
`

export const AdminSchema = Yup.object().shape({
  email: Yup.string()
    .email()
    .trim('Spaces not allowed')
    .strict()
    .required('Email is required'),
  password: Yup.string()
    .trim('Spaces not allowed')
    .required('Password is required')
    .strict(),
  name: Yup.string().trim().required('Name is required').strict(),
})

const AddAdminModal = ({ visible, onClose }) => {
  const [loading, setLoading] = useState(false)
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(AdminSchema),
  })

  const handleFormSubmit = async data => {
    try {
      setLoading(true)
      await UsersService.createAdmin(data)
      notification.success({
        message: 'Success!',
        description: 'Admin Created SuccessFully',
      })
      reset()
      onClose()
    } catch (error) {
      notification.error({
        description: error.toString(),
        message: 'Failed to Create Admin',
      })
    } finally {
      setLoading(false)
    }
  }
  return (
    <Modal
      open={visible}
      title="Add New Admin"
      onCancel={onClose}
      footer={null}
      destroyOnClose
    >
      <Form
        className="mt-5"
        layout="vertical"
        onFinish={handleSubmit(handleFormSubmit)}
      >
        <InputTextField
          name="email"
          label="Email Address"
          control={control}
          errors={errors}
          required
          placeholder="Enter Email Address"
        />

        <InputTextField
          name="password"
          control={control}
          errors={errors}
          label="Password"
          required
          placeholder="Enter your password"
          type="password"
        />

        <InputTextField
          name="name"
          control={control}
          errors={errors}
          label="Name"
          required
          placeholder="Enter your name"
        />

        <ButtonWrapper>
          <PrimaryButton loading={loading} htmlType="submit">
            Submit
          </PrimaryButton>
        </ButtonWrapper>
      </Form>
    </Modal>
  )
}
